import React from "react";
import { Button, Flex } from "antd";
import { PlusOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import AbhaCard from "./AbhaCard";

const STATS = [
  { value: "55Cr+", label: "ABHA IDs Created" },
  { value: "100%", label: "Free for All Citizens" },
  { value: "14-digit", label: "Unique Identifier" },
];

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-bg pt-28 pb-0" style={{ minHeight: "88vh" }}>
      {/* Main hero content */}
      <div className="max-w-7xl mx-auto px-6">
        <Flex
          align="center"
          justify="space-between"
          gap={40}
          wrap="wrap"
          style={{ paddingTop: 48, paddingBottom: 64 }}
        >
          {/* Left column */}
          <div className="flex-1" style={{ minWidth: 300, maxWidth: 580 }}>
            {/* Badge */}
            <div
              className="fade-in-up fade-in-up-delay-1 inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8"
              style={{
                background: "rgba(139, 85, 244, 0.2)",
                border: "1px solid rgba(139, 85, 244, 0.4)",
                backdropFilter: "blur(10px)",
              }}
            >
              <span style={{ fontSize: 16 }}>🇮🇳</span>
              <span
                className="text-xs font-bold tracking-widest"
                style={{ color: "#d4bbff", letterSpacing: "0.1em" }}
              >
                AYUSHMAN BHARAT DIGITAL MISSION
              </span>
            </div>

            {/* Headline */}
            <h1
              className="fade-in-up fade-in-up-delay-2 font-black leading-tight mb-6"
              style={{
                fontSize: "clamp(2rem, 5vw, 3.4rem)",
                color: "#ffffff",
                lineHeight: 1.15,
              }}
            >
              Create Your{" "}
              <em
                style={{
                  color: "#c4a0ff",
                  fontStyle: "italic",
                  fontWeight: 900,
                }}
              >
                ABHA Health
                <br />
                ID
              </em>{" "}
              Card Online
            </h1>

            {/* Description */}
            <p
              className="fade-in-up fade-in-up-delay-3 mb-10 leading-relaxed"
              style={{
                color: "rgba(255,255,255,0.72)",
                fontSize: 16,
                maxWidth: 480,
                lineHeight: 1.75,
              }}
            >
              Our platform supports digital health interoperability aligned with
              the Ayushman Bharat Digital Mission (ABDM) framework. For M1 level
              integration, we collaborated with ABDM-compliant integration
              partners ClinAlly to enable secure health record exchange and
              ecosystem connectivity.
            </p>

            {/* CTA Buttons */}
            <Flex
              gap={16}
              wrap="wrap"
              className="fade-in-up fade-in-up-delay-4"
            >
              <Button
                size="large"
                icon={<PlusOutlined />}
                onClick={() => navigate('/create-abha')}
                className="btn-pink"
                style={{
                  background:
                    "linear-gradient(135deg, #E91E8C 0%, #C41575 100%)",
                  border: "none",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 15,
                  height: 52,
                  paddingInline: 28,
                  borderRadius: 12,
                  boxShadow: "0 6px 20px rgba(233, 30, 140, 0.4)",
                }}
              >
                Create ABHA for Free
              </Button>
              <Button
                size="large"
                icon={<ArrowRightOutlined />}
                iconPlacement="end"
                href="#how-to"
                style={{
                  background: "rgba(255,255,255,0.1)",
                  border: "1px solid rgba(255,255,255,0.25)",
                  color: "#ffffff",
                  fontWeight: 600,
                  fontSize: 15,
                  height: 52,
                  paddingInline: 28,
                  borderRadius: 12,
                  backdropFilter: "blur(10px)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.18)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                }}
              >
                Learn More
              </Button>
            </Flex>
          </div>

          {/* Right column – ABHA Card */}
          <div
            className="flex items-center justify-center"
            style={{ paddingTop: 8 }}
          >
            <AbhaCard />
          </div>
        </Flex>
      </div>

      {/* Stats bar */}
      <div
        style={{
          background: "rgba(0,0,0,0.25)",
          borderTop: "1px solid rgba(255,255,255,0.08)",
          backdropFilter: "blur(10px)",
        }}
      >
        <div className="max-w-7xl mx-auto px-6 py-8">
          <Flex gap={0} wrap="wrap">
            {STATS.map((stat, i) => (
              <div
                key={stat.value}
                className="flex-1"
                style={{
                  minWidth: 160,
                  borderRight:
                    i < STATS.length - 1
                      ? "1px solid rgba(255,255,255,0.12)"
                      : "none",
                  paddingInline: 32,
                  paddingBlock: 8,
                }}
              >
                <p
                  className="stat-number font-black mb-1"
                  style={{
                    fontSize: "clamp(1.8rem, 3vw, 2.5rem)",
                    lineHeight: 1.1,
                  }}
                >
                  {stat.value}
                </p>
                <p
                  className="text-sm font-medium"
                  style={{ color: "rgba(255,255,255,0.6)" }}
                >
                  {stat.label}
                </p>
              </div>
            ))}
          </Flex>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
